import React, { useRef, useEffect, useState } from "react";
export const Temporalizador = ({ SalirSitio }) => {

    // maneja la cantida de segundos posterior al tiempo de inactividad que se le presenta 
    // el modal de inactividad al cliente posterior a este tiempo ejecuta el proceso de logout 
    const [contador, setContador] = useState(100);

    // controla la referencia del intervalo de tiempo
    let intervaloRef = useRef();

    // realiza el proceso de resta de segundos del contador 
    const CuentaRegresiva = () => {
        setContador((prev) => prev - 1);


    }

    // se ejecuta la primera vez y lleva el control de la suscripcion con setInterval del consumo 
    // de la funcion que realiza la cuenta regresiva sobre el contados
    useEffect(() => {
        intervaloRef.current = setInterval(CuentaRegresiva, 1000);
        return () => {
            clearInterval(intervaloRef.current);
        }
    }, []);

    // monitorea el estado de la variable de contador 
    useEffect(() => {
        if (contador === 0) {

            clearInterval(intervaloRef.current);
            SalirSitio();
        }
    }, [contador]);

    return (
        <div>
            <div>
                <h1 > {contador}  </h1>
            </div>
        </div>
    );
};

export default Temporalizador;